import { render } from "./SummaryKDS.vue?vue&type=template&id=63ed7d86&scoped=true"
import script from "./SummaryKDS.vue?vue&type=script&lang=js"
export * from "./SummaryKDS.vue?vue&type=script&lang=js"

import "./SummaryKDS.vue?vue&type=style&index=0&id=63ed7d86&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63ed7d86"]])

export default __exports__